import { render, staticRenderFns } from "./CustomerDashboard.vue?vue&type=template&id=3f4cdd14&scoped=true&"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDashboard.vue?vue&type=style&index=0&id=3f4cdd14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4cdd14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VProgressCircular,VRow})
